import {FC, MouseEvent, useEffect, useState} from 'react';

import {
    genericErrorShowToastOptions
} from '../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import useNavigateWithToast from '../../../utils/useNavigateWithToast/useNavigateWithToast';
import { ClassSizeFormErrors, ClassSizeFormValues} from "../ClassSizeForm/ClassSizeForm.types";
import ClassSizeForm from "../ClassSizeForm/ClassSizeForm";
import UnsavedChangesModal from "../../../common/UnsavedChangesModal/UnsavedChangesModal";
import {useAddClassSize} from "../../../services/size/size.service";
import {AxiosError} from "axios";
import {showToast} from "../../../components/Toast/Toast";
import {ToastTypes} from "../../../components/Toast/Toast.types";

const AddClassSize: FC = () => {
    const navigateWithToast = useNavigateWithToast();
    const { mutate, isLoading} = useAddClassSize();
    const initialFormValues = {
        classNo: undefined,
        sizeNo: undefined,
    };

    const [formValues, setFormValues] = useState<ClassSizeFormValues>({
        classNo: undefined,
        sizeNo: undefined,
    });

    const [formErrors, setFormErrors] = useState<ClassSizeFormErrors>({
        classNo:'',
        sizeNo: '',
    });

    const validateFormValues = () => {
        let error = false;
        let errorMessages: ClassSizeFormErrors = {
            classNo:'',
            sizeNo: '',
        };

        if ([null, undefined, -1].includes(formValues.classNo)) {
            errorMessages.classNo = 'Class Number is required.';
            error = true;
        }

        if ([null, undefined, -1].includes(formValues.sizeNo)) {
            errorMessages.sizeNo = 'Size Number is required.';
            error = true;
        }

        setFormErrors((formErrors) => {
            return { ...formErrors, ...errorMessages };
        });
        return error;
    };
    const [unsavedChanges, setUnsavedChanges] = useState(false);

    const checkForUnsavedChanges = () => {
        if (
            initialFormValues.classNo === formValues.classNo &&
            initialFormValues.sizeNo === formValues.sizeNo
        ) {
            setUnsavedChanges(false);
            return;
        } else {
            setUnsavedChanges(true);
            return;
        }
    };
    useEffect(() => {
        checkForUnsavedChanges();
    }, [formValues]);

    const handleSave = (event: MouseEvent) => {
        event.preventDefault();
        const isError = validateFormValues();
        if (isError) return;
        setUnsavedChanges(false);
        mutate(
            {
                classNo: formValues.classNo as number,
                sizeNo: formValues.sizeNo as number,
            },
            {
                onSuccess: () => {
                    navigateWithToast(`/tables/classsizes`, {
                        label: 'New ClassSize has been added successfully',
                        id: 'classSizeAddSuccess',
                    });
                },
                onError: (e) => {
                    if ((e as AxiosError)?.message === 'Request failed with status code 409') {
                        showToast({
                            label: 'ClassSize already exists.',
                            id: 'addClassSizeIsError',
                            toastType: ToastTypes.Error,
                        });
                    } else {
                        showToast(genericErrorShowToastOptions);
                    }
                },
            }
        );
    };

    return (
        <>
            <ClassSizeForm
                formValues={formValues}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                setFormValues={setFormValues}
                headerTitle={'Add New ClassSize'}
                saveDisabled={!unsavedChanges}
                handleSave={handleSave}
                isButtonLoading={isLoading}
            />
            <UnsavedChangesModal unsavedChangesExist={unsavedChanges} />
        </>
    );
};

export default AddClassSize;
